import styled from 'styled-components';
import { Box } from 'rebass';

import { theme } from '../../styles/theme';

const TwoToneBkg = styled(Box)`
  background-color: ${(props) => props.backgroundLeft};

  @media (min-width: ${theme.breakpoint.md}) {
    background: ${(props) => props.backgroundLeft};
    background: -moz-linear-gradient(
      left,
      ${(props) => props.backgroundLeft} 0%,
      ${(props) => props.backgroundLeft} 50%,
      ${(props) => props.backgroundRight} 50%,
      ${(props) => props.backgroundRight} 50%,
      ${(props) => props.backgroundLeft} 50%,
      ${(props) => props.backgroundLeft} 50%,
      ${(props) => props.backgroundRight} 50%
    );
    background: -webkit-linear-gradient(
      left,
      ${(props) => props.backgroundLeft} 0%,
      ${(props) => props.backgroundLeft} 50%,
      ${(props) => props.backgroundRight} 50%,
      ${(props) => props.backgroundRight} 50%,
      ${(props) => props.backgroundLeft} 50%,
      ${(props) => props.backgroundLeft} 50%,
      ${(props) => props.backgroundRight} 50%
    );
    background: linear-gradient(
      to right,
      ${(props) => props.backgroundLeft} 0%,
      ${(props) => props.backgroundLeft} 50%,
      ${(props) => props.backgroundRight} 50%,
      ${(props) => props.backgroundRight} 50%,
      ${(props) => props.backgroundLeft} 50%,
      ${(props) => props.backgroundLeft} 50%,
      ${(props) => props.backgroundRight} 50%
    );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='${(
      props
    ) => props.backgroundLeft}', endColorstr='${(props) =>
      props.backgroundRight}',GradientType=1 );
  }
`;

export default TwoToneBkg;
